/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import {
	GET_GEARBOX_HSS_UPWINDBEARING_RESULT,
	GET_GEARBOX_HSS_DOWNWINDUPBEARING_RESULT,
	GET_GEARBOX_HSS_DOWNWINDDOWNBEARING_RESULT,
	GET_GEARBOX_IMS_UPWINDBEARING_RESULT,
	GET_GEARBOX_IMS_DOWNWINDBEARING_RESULT,
	GET_GEARBOX_LSS_UPWINDBEARING_RESULT,
	GET_GEARBOX_LSS_DOWNWINDUPBEARING_RESULT,
	GET_GEARBOX_LSS_DOWNWINDDOWNBEARING_RESULT,
	GET_GEARBOX_PLANETARY_BEARING_RESULT,
	GET_GEARBOX_PLANETARY_DOWNWINDBEARING_RESULT,
	GET_GEARBOX_PLANETARY_UPWINDBEARING_RESULT,
	GET_GEARBOX_HSS_UPWINDBEARING_SUCCESS,
	GET_GEARBOX_HSS_DOWNWINDUPBEARING_SUCCESS,
	GET_GEARBOX_HSS_DOWNWINDDOWNBEARING_SUCCESS,
	GET_GEARBOX_IMS_UPWINDBEARING_SUCCESS,
	GET_GEARBOX_IMS_DOWNWINDBEARING_SUCCESS,
	GET_GEARBOX_LSS_UPWINDBEARING_SUCCESS,
	GET_GEARBOX_LSS_DOWNWINDUPBEARING_SUCCESS,
	GET_GEARBOX_LSS_DOWNWINDDOWNBEARING_SUCCESS,
	GET_GEARBOX_PLANETARY_BEARING_SUCCESS,
	GET_GEARBOX_PLANETARY_DOWNWINDBEARING_SUCCESS,
	GET_GEARBOX_PLANETARY_UPWINDBEARING_SUCCESS,
	GET_GEARBOX_BEARING_RESULT_ERROR,
	RESET_GEARBOX_BEARING_RESULT,
} from "@/stores/actions/WindDiagnosticGearboxBearingsResult";
import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";

const state = {
	status:            FetchStatus.Init,
	hssfaUpWind:       {},
	hssfaDownWindUp:   {},
	hssfaDownWindDn:   {},
	imsfaUpWind:       {},
	imsfaDownWind:     {},
	lssfaUpWind:       {},
	lssfaDownWindUp:   {},
	lssfaDownWindDown: {},
	cageFAPlan:        {},
	cageFADownWind:    {},
	cageFAUpWind:      {},
	data:              {},
	error:             {},
};

const actions = {
	[GET_GEARBOX_HSS_UPWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_HSS_UPWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_HSS_UPWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_HSS_DOWNWINDUPBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_HSS_DOWNWINDUPBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_HSS_DOWNWINDUPBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_HSS_DOWNWINDDOWNBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_HSS_DOWNWINDDOWNBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_HSS_DOWNWINDDOWNBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_IMS_UPWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_IMS_UPWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_IMS_UPWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_IMS_DOWNWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_IMS_DOWNWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_IMS_DOWNWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_LSS_UPWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_LSS_UPWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_LSS_UPWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_LSS_DOWNWINDUPBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_LSS_DOWNWINDUPBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_LSS_DOWNWINDUPBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_LSS_DOWNWINDDOWNBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_LSS_DOWNWINDDOWNBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_LSS_DOWNWINDDOWNBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_PLANETARY_BEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_PLANETARY_BEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_PLANETARY_BEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_PLANETARY_DOWNWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_PLANETARY_DOWNWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_PLANETARY_DOWNWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_GEARBOX_PLANETARY_UPWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_GEARBOX_PLANETARY_UPWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/GearboxBearings`)
			.then((resp) =>
			{
				commit(GET_GEARBOX_PLANETARY_UPWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_GEARBOX_BEARING_RESULT_ERROR, error.response);
			});
	},
	[RESET_GEARBOX_BEARING_RESULT]: ({ commit }) =>
	{
		commit(RESET_GEARBOX_BEARING_RESULT);
	},
};

const mutations = {
	[GET_GEARBOX_HSS_UPWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_HSS_DOWNWINDUPBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_HSS_DOWNWINDDOWNBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_IMS_UPWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_IMS_DOWNWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_LSS_UPWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_LSS_DOWNWINDUPBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_LSS_DOWNWINDDOWNBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_PLANETARY_BEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_PLANETARY_DOWNWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_GEARBOX_PLANETARY_UPWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},

	[GET_GEARBOX_HSS_UPWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.hssfaUpWind = data.hssfaUpWind;
	},
	[GET_GEARBOX_HSS_DOWNWINDUPBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.hssfaDownWindUp = data.hssfaDownWindUp;
	},
	[GET_GEARBOX_HSS_DOWNWINDDOWNBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.hssfaDownWindDn = data.hssfaDownWindDn;
	},
	[GET_GEARBOX_IMS_UPWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.imsfaUpWind = data.imsfaUpWind;
	},
	[GET_GEARBOX_IMS_DOWNWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.imsfaDownWind = data.imsfaDownWind;
	},
	[GET_GEARBOX_LSS_UPWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.lssfaUpWind = data.lssfaUpWind;
	},
	[GET_GEARBOX_LSS_DOWNWINDUPBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.lssfaDownWindUp = data.lssfaDownWindUp;
	},
	[GET_GEARBOX_LSS_DOWNWINDDOWNBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.lssfaDownWindDown = data.lssfaDownWindDown;
	},
	[GET_GEARBOX_PLANETARY_BEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.cageFAPlan = data.cageFAPlan;
	},
	[GET_GEARBOX_PLANETARY_DOWNWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.cageFADownWind = data.cageFADownWind;
	},
	[GET_GEARBOX_PLANETARY_UPWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.status = FetchStatus.Loaded;
		state.cageFAUpWind = data.cageFAUpWind;
	},
	[GET_GEARBOX_BEARING_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_GEARBOX_BEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.data = DiagnosticRange.undefined;
		state.hssfaUpWind = DiagnosticRange.undefined;
		state.hssfaDownWindUp = DiagnosticRange.undefined;
		state.hssfaDownWindDn = DiagnosticRange.undefined;
		state.imsfaUpWind = DiagnosticRange.undefined;
		state.imsfaDownWind = DiagnosticRange.undefined;
		state.lssfaUpWind = DiagnosticRange.undefined;
		state.lssfaDownWindUp = DiagnosticRange.undefined;
		state.lssfaDownWindDown = DiagnosticRange.undefined;
		state.cageFAPlan = DiagnosticRange.undefined;
		state.cageFADownWind = DiagnosticRange.undefined;
		state.cageFAUpWind = DiagnosticRange.undefined;
	},
};

export default {
	state,
	actions,
	mutations,
};
